//
import Avatar from './Avatar';
import useAuth from '../hooks/useAuth';

// ----------------------------------------------------------------------

// Stored profile_image is a Flutter asset path e.g. "assets/avatar/male/4.webp".
// On the web we serve it from /public/avatar, so strip the leading "assets/".
const avatarUrl = (p) => (p ? `/${String(p).replace(/^assets\//, '')}` : '/avatar/default.webp');

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();
  return (
    <Avatar
      src={avatarUrl(user?.profile_image)}
      alt={user?.name || user?.username || 'User'}
      {...other}
    />
  );
}
